/**
 * Created by Ding on 13/07/2017.
 */

import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { Form, Input, Checkbox, Button, Icon, Row, Col, message } from 'antd';
import { ajaxGet, ajaxPost } from '../../utils/ajax';

const FormItem = Form.Item;


class LoginForm extends Component {
    static propTypes = {
        handleSubmit: PropTypes.func.isRequired,
        form: PropTypes.object.isRequired,
    };

    state = {
        verifyCodeKey: Math.random(),
        checkbox: false,
    };

    onSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                if (!this.state.checkbox) {
                    message.warning('请阅读并勾选用户协议及隐私政策');
                    return;
                }
                this.props.handleSubmit(values, () => {
                    // 授权记录
                    const permData = {
                        signType: '0',
                        extra: {
                            source: '4',
                            type: '1',
                            isAgree: true,
                        },
                    };
                    ajaxPost('/recruit/api/hunter/perm/userSign', permData);
                    this.setState({
                        verifyCodeKey: Math.random(),
                    });
                });
            }
        });
    };

    validateCode = (rule, value, callback) => {
        if (value) {
            ajaxGet(
                '/api/hunter/verifyCode',
                { verifyCode: value },
                () => callback(),
                rawData => callback(rawData.meta.message),
            );
        } else {
            callback();
        }
    };

    getPermUrl = (url) => {
        ajaxGet(url, {}, ({ data }) => {
            if (data && data.signFileUrl) {
                window.open(`${data.signFileUrl}#toolbar=0`);
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = {
            labelCol: {
                sm: { span: 4 },
            },
            wrapperCol: {
                sm: { span: 20 },
            },
        };
        const verifiyCodeLayout = {
            labelCol: {
                sm: { span: 4 },
            },
            wrapperCol: {
                sm: { span: 10 },
            },
        };
        const tailFormItemLayout = {
            wrapperCol: {
                sm: { span: 20, offset: 4 },
            },
        };

        return (
            <Form onSubmit={this.onSubmit}>
                <FormItem
                    {...formItemLayout}
                    label="邮箱"
                    hasFeedback
                >
                    {getFieldDecorator('usr', {
                        rules: [
                            { type: 'email', message: '输入的邮箱格式非法' },
                            { required: true, message: '请输入您的邮箱', whitespace: true },
                        ],
                    })(<Input placeholder="请输入邮箱" maxLength="45" />)}
                </FormItem>

                <FormItem
                    {...formItemLayout}
                    label="密码"
                    hasFeedback
                >
                    {getFieldDecorator('pwd', {
                        rules: [{ required: true, message: '请输入您的密码' }],
                    })(<Input type="password" placeholder="请输入密码" maxLength="45" />)}
                </FormItem>

                <FormItem
                    {...verifiyCodeLayout}
                    label="验证码"
                    hasFeedback
                >
                    {getFieldDecorator('verifyCode', {
                        validateTrigger: 'onBlur',
                        rules: [
                            { required: true, message: '请输入验证码' },
                            { validator: this.validateCode },
                        ],
                    })(<Input placeholder="请输入验证码" maxLength="4" />)}
                </FormItem>

                <div
                    style={{
                        position: 'absolute',
                        top: '228px',
                        right: '115px',
                        cursor: 'pointer',
                    }}
                    onClick={() => {
                        this.setState({
                            verifyCodeKey: Math.random(),
                        });
                    }}
                    role="button"
                    tabIndex="0"
                >
                    <img
                        src={`/api/verifyCode.jpg?t=${this.state.verifyCodeKey}`}
                        alt="verifyCode"
                    />
                </div>

                <Icon
                    type="reload"
                    style={{
                        position: 'absolute',
                        top: '236px',
                        right: '81px',
                        fontSize: '14px',
                        color: '#fc9153',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                    }}
                    onClick={() => {
                        this.setState({
                            verifyCodeKey: Math.random(),
                        });
                    }}
                />

                <FormItem {...tailFormItemLayout} style={{ margin: '-5px 0 25px' }}>
                    {getFieldDecorator('remember', {
                        valuePropName: 'checked',
                        initialValue: true,
                    })(<Checkbox>下次自动登录</Checkbox>)}
                </FormItem>

                <FormItem {...tailFormItemLayout}>
                    <Button type="primary" htmlType="submit" style={{ width: '100%', fontSize: '14px' }}>
                        登录
                    </Button>
                </FormItem>

                <FormItem {...tailFormItemLayout} style={{ marginTop: '-15px' }}>
                    <Row>
                        <Col span={12}>
                            {/* <a href="" onClick={e => e.preventDefault()}>注册</a> */}
                        </Col>
                        <Col span={12} style={{ textAlign: 'right' }}>
                            <Link to="/reset">忘记密码?</Link>
                        </Col>
                    </Row>
                </FormItem>
                <div className="CheckboxConent">
                    <Checkbox value={this.state.checkbox} onChange={e => this.setState({ checkbox: e.target.checked })}>我已阅读并同意
                    </Checkbox>
                    <span role="button" onClick={() => this.getPermUrl('/recruit/api/hunter/perm/getUserTemplate')} tabIndex="0" className="CheckboxA">用户协议</span>与
                    <span role="button" onClick={() => this.getPermUrl('/recruit/api/hunter/perm/getPrivacyPolicyTemplate')} tabIndex="0" className="CheckboxA">隐私政策</span>
                </div>
            </Form>
        );
    }
}

export default Form.create({})(LoginForm);
